import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useMatches } from "react-router-dom";
import { Spin } from "antd";
import { observer } from "mobx-react-lite";

import AppFooter, {
  type AppFooterVariant,
} from "../components/layout/AppFooter";
import { userStore } from "../stores/userStore";

interface RouteHandle {
  footerVariant?: AppFooterVariant;
}

export const EntryLayout = observer(function EntryLayout() {
  const location = useLocation();
  const matches = useMatches();

  useEffect(() => {
    userStore.load();
  }, []);

  if (userStore.authed === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (userStore.authed) {
    const next = new URLSearchParams(location.search).get("next");
    const profileSearch = next?.startsWith("contact")
      ? `?${new URLSearchParams({ next })}`
      : "";
    return <Navigate to={`/profile${profileSearch}`} replace />;
  }

  const footerVariant = matches
    .map((m) => (m.handle as RouteHandle | undefined)?.footerVariant)
    .find(Boolean);

  return (
    <div className="entry-layout">
      <Outlet />
      <AppFooter variant={footerVariant} />
    </div>
  );
});
